<template>
    <VJoyHighlight level="error" :accent="false" :display-icon="true">
        <div>
            {{ t('profile.alert.broken.pictures.message') }}
            <VJoyLink href="#" :text="t('profile.alert.broken.pictures.link')" @click="openPhotoEdition" />
        </div>
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyHighlight, VJoyLink} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';

    const {t} = useTranslation();

    function openPhotoEdition() {
        eventBus.emit('photo:edit-mode', {entryPoint: EditionOpenedEntryPoint.PROFILE_ALERT});
    }
</script>
